import { createFileRoute } from '@tanstack/react-router'

import { BucketDetailPage } from '@/pages/settings/BucketDetailPage.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/$bucketId',
)({
  component: BucketDetailPage,
})
